import { StapleTableCell } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FileNameStyled = styled.span`
  margin-left: 1rem;
  word-break: break-all;
`;

export const StapleTableCellStyled = styled(StapleTableCell)`
  text-align: right;

  &:last-child {
    padding-right: 3rem;
  }
`;
